import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LearningTypeFactory } from '@app/factories/_index';
import { LearningType } from '@app/models/_index';
import { ComponentsModule } from '../../components.module';
import { DurationComponent } from '../duration/duration.component';

@Component({
  selector: 'app-course-instruction-type',
  imports: [CommonModule, DurationComponent, ComponentsModule],
  templateUrl: './course-instruction-type.component.html',
  styleUrls: ['./course-instruction-type.component.scss'],
})
export class CourseInstructionTypeComponent implements OnInit {
  learningTypes: LearningType[] = [];

  @Input() instructionType: string;
  @Input() courseDuration: number;
  @Input() printFlag: boolean;
  @Input() durationFlag: boolean;
  @Input() instructionTypeFlag: boolean;

  constructor(private learningTypeFactory: LearningTypeFactory) {}

  /**
   * OnInit - get all static learning types from learning type factory
   */
  ngOnInit(): void {
    // Return static learning types from factory
    this.learningTypes = this.learningTypeFactory.getCollection();
  }

  /**
   * Return instruction type tooltip for a given instruction type
   * @param courseType - instruction type string
   * @returns - instruction type tooltip string
   */
  getInstructionTypeTooltip(instructionType: string): string {
    let tooltip: string;
    this.learningTypes.forEach((learningType) => {
      if (instructionType === learningType.value) {
        tooltip = learningType.tooltip;
      }
    });

    return tooltip;
  }
}
